import moment from "moment";
import {isEmpty} from "@/util/Helpers";
import {INVALID_DATE} from "@/util/EnumUtil";

export const dateToEpoch = (value) => {
    if (!isEmpty(value) && value !== INVALID_DATE) {
        let val = moment(value, 'YYYY-MM-DD HH:mm:ss').valueOf()
        return moment(val).format('DD/MM/YYYY')
    }
}

// export const dateToEpoch = (value) => {
//     if (!isEmpty(value) && value !== INVALID_DATE) {
//         // return moment.tz(value, 'DD/MM/YYYY', "Europe/Athens").add(5, 'hours').valueOf()
//         return moment(value, 'DD/MM/YYYY').add(5, 'hours').valueOf()
//     }
//     return null
// }

export const dateToEpoch2 = (value) => {
    if (!isEmpty(value) && value !== INVALID_DATE) {
        let date = moment(value, 'YYYY-MM-DD HH:mm:ss').add(5, 'hours').valueOf()
        return date
    }
}

export const epochToDate = (value) => {
    if (!isEmpty(value) && value !== INVALID_DATE) {
        let val = moment(value)
        // const newDate = moment(moment.tz(val, 'DD/MM/YYYY', "Europe/Athens").add(5, 'hours').valueOf())
        const newDate = moment(moment(val, 'DD/MM/YYYY').add(5, 'hours').valueOf())
        return newDate.format('DD/MM/YYYY')
    }
    return null
}


// export const epochToDate = (value) => {
//     if (!isEmpty(value) && value !== INVALID_DATE) {
//         let val = moment(parseInt(value))
//         return val.format('DD/MM/YYYY')
//     }
//     return null
// }
export const epochToDateTime = (value) => {
    if (!isEmpty(value) && value !== INVALID_DATE) {
        let val = moment(parseInt(value))
        return val.format('DD/MM/YYYY HH:mm:ss')
    }
    return null
}

export const formatDateGRDefault = (value) => {
    if (!isEmpty(value) && value !== '' && value !== INVALID_DATE) {
        if (moment(value, 'YYYY-MM-DD', true).isValid()) {
            let epochDate = moment(value, 'YYYY-MM-DD').valueOf()
            return moment(epochDate).format('DD/MM/YYYY');
        } else if (moment(value, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
            let epochDate = moment(value, 'YYYY-MM-DD HH:mm:ss').valueOf()
            return moment(epochDate).format('DD/MM/YYYY');
        } else {
            let epochDate = moment(value, 'DD/MM/YYYY').valueOf()
            return moment(epochDate).format('DD/MM/YYYY');
        }
    }
}

export const formatDateUTCDefault = (value) => {
    let epochDate
    if (!isEmpty(value) && value !== '' && value !== INVALID_DATE) {
        if (moment(value, 'YYYY-MM-DD', true).isValid()) {
            epochDate = moment(value).utc().utcOffset('+03:00').format('YYYY-MM-DD HH:mm:ss').valueOf()
        } else if (moment(value, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
            epochDate = moment(value).set("hours", 23).set("minute", 59).format('DD/MM/YYYY').valueOf()
        } else {
            epochDate = moment(value, 'DD/MM/YYYY').add(5, 'hours').valueOf()
        }
    }
    return new Date(epochDate);
}

export const formatDateDefault = (value) => {
    let epochDate
    if (!isEmpty(value) && value !== '' && value !== INVALID_DATE) {
        if (moment(value, 'YYYY-MM-DD', true).isValid()) {
            let val = moment(value, 'YYYY-MM-DD')
            epochDate = val.format('YYYY-MM-DD HH:mm:ss')
        } else if (moment(value, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
            epochDate = moment(value, 'DD/MM/YYYY').valueOf()
        } else if (moment(value, 'DD/MM/YYYY', true).isValid()) {
            let val = moment(value, 'DD/MM/YYYY')
            epochDate = val.format('YYYY-MM-DD HH:mm:ss')
        } else {
            let val = moment(value)
            epochDate = val.format('YYYY-MM-DD HH:mm:ss')
        }
    }
    return epochDate;
}
export const formatDateWithFormat = (value) => {
    if (!isEmpty(value) && value !== '' && value !== INVALID_DATE) {
        if (moment(value, 'YYYY-MM-DD', true).isValid()) {
            let epochDate = moment(value, 'YYYY-MM-DD').valueOf()
            return moment(epochDate).format('DD/MM/YYYY');
        } else if (moment(value, 'DD/MM/YYYY', true).isValid()) {
            let epochDate = moment(value, 'DD/MM/YYYY').valueOf()
            return moment(epochDate).format('YYYY-MM-DD');
        } else if (moment(value, 'YYYY/MM/DD HH:mm:ss', true).isValid()) {
            let epochDate = moment(value, 'YYYY/MM/DD HH:mm:ss').valueOf()
            return moment(epochDate).format('DD/MM/YYYY HH:mm:ss');
        } else if (moment(value, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
            let epochDate = moment(value, 'YYYY-MM-DD HH:mm:ss').valueOf()
            return moment(epochDate).format('DD/MM/YYYY HH:mm:ss');
        } else {
            let epochDate = moment(value, 'DD/MM/YYYY HH:mm:ss').valueOf()
            return moment(epochDate).format('DD/MM/YYYY HH:mm:ss');
        }
    }
}
export const formatDateTime = (value) => {
    if (value != null && value !== '' && value !== undefined && value.toString() !== 'Invalid Date') {
        let myDate = moment(value);
        return moment(myDate).format('DD/MM/YYYY HH:mm:ss');
    } else {
        return null;
    }
}